/**
 * Configure your Gatsby site with this file.
 *
 * See: https://www.gatsbyjs.com/docs/gatsby-config/
 */

module.exports = {
  /* Your site config here */
  siteMetadata: {
    title: `Abhishek Shukla`,
    description: `Abhishek Shukla is a software engineer with strong expertise in frontend domain working in ReactJS , NextJS and GatsbyJS`,
    defaultDescription: `Abhishek Shukla is a software engineer with strong expertise in frontend domain working in ReactJS , NextJS and GatsbyJS`,
    titleTemplate: `%s | Abhishek Shukla`,
    url: `https://www.abshukla.com/`,
    twitterUsername: `@abhishek_shukla`,
    image: `./abhishek.png`,
  },
  plugins: [
    `gatsby-plugin-image`,
    `gatsby-plugin-sharp`,
    `gatsby-transformer-sharp`,
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `images`,
        path: `${__dirname}/src/assets/images`,
      },
    },
    `gatsby-plugin-react-helmet`,
  ],
}
